import './SubPackages.scss';

import type { FC } from 'react';
import { sortBy } from 'lodash-es';

import groupBy from 'utils/groupBy';
import PackageCell, { Props as PackageCellProps } from './PackageCell';

interface Props extends PackageCellProps {}

const SubPackages: FC<Props> = (props) => {
  const { licenseOption, family, faces, onHover, disabled } = props;

  const facesGroupedByWidth = groupBy(
    sortBy(faces, (face) => face.width.position),
    (face) => face.width.name,
  );

  return (
    <div className="SubPackages">
      {facesGroupedByWidth.map(({ name: width, elements: faces }) => (
        <PackageCell
          key={width}
          licenseOption={licenseOption}
          family={family}
          faces={faces}
          width={width}
          disabled={disabled}
          onHover={onHover}
        />
      ))}
    </div>
  );
};

export default SubPackages;
